// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCompetitorsButton_wrapper__RJpHm"};